export default __webpack_public_path__ + "static/media/Chika2.50af379e.png";